<template lang="pug">
v-container 
  v-card
    v-card-title Privilegios 
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar permisos' single-line hide-details)
      v-dialog(v-model='Privileges.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn( small color='primary' dark v-on='on' @click='clearForm()' rounded)
            v-icon(small) fa-plus 
        v-card
          v-card-title
            span.headline {{ title }}
          v-card-text
            v-form(autocomplete='false')
              v-container(grid-list-md)
                v-layout(wrap)
                  v-flex(xs12)
                    v-text-field(v-model='data.order' label='Orden' type='number')
                  v-flex(xs12)
                    v-text-field(v-model='data.name' label='Nombre')
                  v-flex(xs12)
                    v-text-field(v-model='data.routerName' label='Nombre de la ruta')
                  v-flex(xs12)
                    v-text-field(v-model='data.icon' label='Icono')
                    v-icon {{data.icon}}
                  v-flex(xs12)
                    v-switch(v-model='data.type' :label='data.type? "Principal":"Opciones"')
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='save()') Guardar
    v-data-table.elevation-1(:headers='headers' :items='PrivilegesRecord' :search='search')
      template(v-slot:item.icon='{item}')
        v-icon {{ item.icon }}
      template(v-slot:item.type='{item}')
        span {{ item.type ? "Principal" : "Opciones" }}
      template(v-slot:item.actions='{item}')
        v-row.justify-center
          v-btn(color='secondary' icon @click='editItem(item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(item.key)')
            v-icon(small) far fa-trash-alt
</template>
<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Lista de Privilegios',    value: 'name'},
      { text: 'Nombre de ruta',          value:'routerName'},
      { text: 'Icono',                   value:'icon'},
      { text: 'Tipo',                    value:'type'},
      { text: 'Orden',                    value:'order'},
      { text: 'Fecha de creación',       value: 'createdAt' },
      { text: '',                 value: 'actions', sortable: false }
    ],
  }),
    methods: {
      ...mapActions({
        editItem: 'Privileges/get',
        deleteItem: 'Privileges/clean',
        save: 'Privileges/add',
        clearForm: 'Privileges/clearForm',
      }),
    },
    computed: {
      title(){ return this.Privileges.selectedKey=='' ? 'Registar' : 'Crear' },
      titleButton() { return this.Privileges.selectedKey == "" ? 'Guardar' : 'Editar' },
      ...mapGetters({
          PrivilegesRecord: 'Privileges/record'
        }),
        ...mapState({
      data: state=> state.Privileges.data,
      Privileges :state=> state.Privileges,
    })
  }
}
</script>